import { Injectable } from '@angular/core';
import { BaseIndexedDbService } from "@core/storage/indexedDb/_database.service";
import { STORAGE_KEYS } from "@core/storage/indexedDb/_database.constants";
import { WorkTimeEntryRequest } from "@api/api";

/**
 * Extra (nem vezetéssel töltött) munkaidő-tételek offline tára (E1.5).
 *
 * A menetigazolványhoz tartozó szolgálati tétel NEM ide kerül: az a menetigazolvány
 * payloadjába ágyazott `workTime` blokkban utazik, és a `travel-document` store-ral
 * együtt szinkronizálódik.
 */
@Injectable({
  providedIn: 'root',
})
export abstract class WorkTimeEntryIndexedDbService extends BaseIndexedDbService<WorkTimeEntryRequest> {
  override objectStoreName = STORAGE_KEYS.workTimeEntry;

  /**
   * Extra tétel mentése azonnal véglegesített állapotban.
   *
   * Az extra tételnek - a menetigazolvánnyal ellentétben - nincs külön véglegesítési lépése:
   * a felvitel pillanatában teljes. A `BaseSynchronizeService` viszont csak a `finalized = 1`
   * tételeket tölti fel, ezért a mentés után azonnal véglegesítjük.
   */
  public async addFinalizedItem(item: WorkTimeEntryRequest): Promise<number> {
    const id = await this.addItem(item);
    await this.updateItem({id, data: item, synced: 0, finalized: 1, deleted: 0});
    return id;
  }
}
